import React, { createContext, useRef, useState } from 'react';
import io from 'socket.io-client';
import { v4 as uuid } from 'uuid';

import environment from '../../environments';
import api from '../../common/api/api';
import { Session, SessionSource } from './Session.interface';

export interface SessionContextState {
  clientId: string;
  sessions: Session[];
  socket?: SocketIOClient.Socket;
}

export const SessionContext = createContext<SessionContextState | undefined>(
  undefined
);

export const useSession = () => {};

export const SessionProvider: React.FC = props => {
  const { children } = props;
  const [sessions] = useState([]);
  const { apiBaseUrl } = environment;
  const clientIdRef = useRef(uuid());
  const socketRef = useRef(
    io(apiBaseUrl, {
      query: {
        clientId: clientIdRef.current,
        token: api.getAccessToken(),
        source: SessionSource.Web
      }
    })
  );

  console.log('SessionProvider render clientIdRef', clientIdRef.current);
  return (
    <SessionContext.Provider
      value={{
        socket: socketRef.current,
        clientId: clientIdRef.current,
        sessions
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
